import { animated, useSpring, useSprings } from '@react-spring/web';
import React from 'react';
import styled from 'styled-components';
import { MediaAssets } from '../services/ofertas-service/models/ofertas';

const CarImagesRow = styled(animated.div)<{ imageWidth: number }>`
	width: ${(props) => props.imageWidth}%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: relative;
`;

const CarImage = styled(animated.img)`
	z-index: -1;
	height: 100%;
`;

export const Carrousel = ({
	mediaAssets,
}: {
	mediaAssets: MediaAssets;
}): React.ReactElement => {
	const turntable = [
		'D6Turntable1',
		'D6Turntable3',
		'D6Turntable5',
		'D6Turntable6',
		'D6Turntable7',
		'D6Turntable9',
		'D6Turntable12',
	];
	const carImages = turntable
		.map((turntable) => mediaAssets[turntable])
		.filter((image) => image !== null && image !== undefined);

	const baseTime = 15000;
	const time = baseTime * carImages.length;

	const imageWidth = 65;

	const props = useSpring({
		from: { x: 30 },
		to: async (next) => {
			await next({
				x: -imageWidth * carImages.length + 100,
				config: { duration: time },
			});
		},
	});

	const delayFactor = 1.2;

	const fades = useSprings(
		carImages.length,
		carImages.map((_, i) => ({
			from: { opacity: 1 },
			to: async (next: any) => {
				await next({ opacity: 0.25, config: { duration: 3000 } });
			},
			delay: 4000 + (time / carImages.length) * i * delayFactor,
		})),
	);

	return (
		<CarImagesRow
			imageWidth={imageWidth}
			style={{
				transform: props.x.to((x) => `translateX(${x}%)`),
			}}
			className="car-images-row"
		>
			{carImages.map((image, index) => (
				<CarImage
					key={index}
					src={`${image}`}
					alt={`${image}`}
					style={{ width: `${imageWidth}%`, opacity: fades[index].opacity }}
					className="car-image"
				/>
			))}
		</CarImagesRow>
	);
};
